import { render, staticRenderFns } from "./AnketsConfig.vue?vue&type=template&id=103a70be&scoped=true"
import script from "./AnketsConfig.vue?vue&type=script&lang=js"
export * from "./AnketsConfig.vue?vue&type=script&lang=js"
import style0 from "./AnketsConfig.vue?vue&type=style&index=0&id=103a70be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a70be",
  null
  
)

export default component.exports